exports = module.exports = require("../../../../../../../shared/frontend/node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.v-note-wrapper[data-v-1a0bb7a9] {\n  min-height: 500px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/css-loader?{"minimize":false,"sourceMap":false}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/style-compiler?{"id":"data-v-1a0bb7a9","scoped":true,"hasInlineConfig":true}!/home/alarmplan/staging/shared/frontend/~/sass-loader?{"sourceMap":false}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Techcenter/components/TcTextArea.vue
// module id = 779
// module chunks = 1